import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { END_POINTS_PATH } from '../../../routes/paths';
import { EntityServices } from '../../../Services/EntityServices';
import { APICredentials } from '../../../types/types';
import { settingsKeys } from './queryKeys';
import ShowSnackbar from '../../../Services/snackbar';
import { HOST_API_URL_V2 } from '../../../config';

const svc = new EntityServices<APICredentials>();

export const useApiCredentialsList = () => {
  return useQuery({
    queryKey: settingsKeys.apiCredentials(),
    queryFn: async () => {
      const res = await svc.GetAllAsync(`${HOST_API_URL_V2}${END_POINTS_PATH.APICredentials}`, undefined, undefined, undefined, true);
      if (res?.statusCode === 200) return res.data || [];
      throw new Error(res?.message || 'Failed to load credentials');
    }
  });
};

export const useGenerateCredential = (apiKey: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await svc.AddFromAnotherModelAsync<any>(`${HOST_API_URL_V2}${END_POINTS_PATH.APICredentials}/generate`, { apiKey: apiKey }, undefined, true);
      if (res?.statusCode === 201 || res?.statusCode === 200) return res.data;
      throw new Error(res?.message || 'Generation failed');
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: settingsKeys.apiCredentials() });
    },
    onError: (err: any) => ShowSnackbar(err.message || 'Generation failed', 'danger')
  });
};

export const useDeleteCredential = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const ok = await svc.DeleteAsync(HOST_API_URL_V2 + END_POINTS_PATH.APICredentials, id, undefined, true);
      if (!ok) throw new Error('Delete failed');
      return id;
    },
    onSuccess: () => {
      ShowSnackbar('Deleted', 'primary');
      qc.invalidateQueries({ queryKey: settingsKeys.apiCredentials() });
    },
    onError: (err: any) => ShowSnackbar(err.message || 'Delete failed', 'danger')
  });
};
